import { QueryValidator } from '@atlassian/amkt-common';
import Immutable from 'immutable';
import { getFilters } from "../config/filters";
import { DISJUNCTIVE_FACET_TYPE } from "../records/FacetType";
export function valuedFilters(filters) {
  return filters.filter(f => Immutable.Iterable.isIterable(f) ? f.size : f);
}
const filtersValidator = getFilters().reduce((validator, f) => {
  if (f.get('custom')) {
    return validator.addOneOfValidator(f.get('key'), f.get('customFilters').map(cf => cf.get('value')).toSet(), f.get('type') === DISJUNCTIVE_FACET_TYPE);
  } else {
    return validator;
  }
}, new QueryValidator());
export function validateFilters(filters) {
  return filtersValidator.validate(filters);
}
export function shouldFacetBeShown(facetKey, hiddenFilters) {
  return hiddenFilters.get(facetKey) !== true;
}
export function shouldFacetProductBeShown(facetKey, facetProductKey, hiddenFilters) {
  const hiddenFilter = hiddenFilters.get(facetKey);

  if (hiddenFilter !== undefined) {
    return Immutable.Set.isSet(hiddenFilter) ? !hiddenFilter.includes(facetProductKey) : shouldFacetBeShown(facetKey, hiddenFilters);
  } else {
    return true;
  }
}
export function shouldCloudForitifedFacetProductBeShown(value, enableCloudFortifiedAppsDiscovery) {
  return value !== 'cloudFortified' || enableCloudFortifiedAppsDiscovery;
}